// @flow
import * as React from 'react';
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { trackEvent } from '../../../tracking/actions';
import { expiredAdImpressionEvent } from '../../../tracking/events';
import ExpiredAdComponent from './index';

type Props = {
  trackEvent: Function,
};

type State = {
  showMessage: string,
};

type MapDispatchToProps = {
  trackEvent: Function,
};

class ExpiredAd extends React.Component<Props, State> {
  state = {
    showMessage: 'shown',
  };

  componentDidMount() {
    this.props.trackEvent(expiredAdImpressionEvent());
    window.setTimeout(() => {
      this.handleClose();
    }, 5000);
  }

  handleClose = () => {
    this.setState({ showMessage: 'hidding' });
    window.setTimeout(() => {
      this.setState({ showMessage: '' });
    }, 500);
  };

  render() {
    return (
      <ExpiredAdComponent
        showMessage={this.state.showMessage}
        handleClose={this.handleClose}
        {...this.props}
      />
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    trackEvent: event => dispatch(trackEvent(event)),
  };
}

const ExpiredAdContainer = connect(
  null,
  mapDispatchToProps
)(ExpiredAd);
ExpiredAdContainer.displayName = 'ExpiredAdContainer';

export default ExpiredAdContainer;



// WEBPACK FOOTER //
// ./app/Serp/components/ExpiredAd/container.js